module.exports = __webpack_public_path__ + "static/placeholdersYes-1382c1eba99fd7a01b826dd547e3e491.png";